// extracted by mini-css-extract-plugin
export var boldText = "_3p-4";
export var checkboxContainer = "_3p-6";
export var closeIcon = "_3p-g";
export var container = "_3p-0";
export var drawer = "_3p-8";
export var drawerContent = "_3p-9";
export var extraSmallText = "_3p-5";
export var fulfillmentGroupTable = "_3p-e";
export var largeText = "_3p-3";
export var loadingSpinnerContainer = "_3p-h";
export var mediumText = "_3p-2";
export var narrow = "_3p-f";
export var notificationLink = "_3p-j";
export var packageCheckIconContainer = "_3p-7";
export var slideoutHeaderContainer = "_3p-a";
export var slideoutModal = "_3p-c";
export var stickyHeaderWrapper = "_3p-b";
export var table = "_3p-i";
export var tableContainer = "_3p-d";
export var tertiaryText = "_3p-1";